import script from "./ux-settings-editor-form.vue?vue&type=script&setup=true&lang=js"
export * from "./ux-settings-editor-form.vue?vue&type=script&setup=true&lang=js"

import "./ux-settings-editor-form.vue?vue&type=style&index=0&id=2e404184&lang=scss"

const __exports__ = script;

export default __exports__